import React from "react";
import { alertService } from "../common/alert.service";

class Collapsible extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: true,
      disabled: props.disabled || false,
      disabledMessage:
        props.disabledMessage || "This action is currently disabled.",
    };
  }

  //For a stylable implementation
  //pass in:
  // this.props.containerClass  =   classnames of overall container
  // this.props.closedContainerClass  = classname of container when closed

  //To fill the component pass in:
  // this.props.open   =   element displayed when open
  // this.props.closed  = element displayed when closed

  render() {
    if (!this.state.hidden) {
      return (
        <div className={`collapsible ${this.props.containerClass || ""} `}>
          <div
            className="panel circleIcon"
            onClick={() => this.setState({ hidden: true })}
          >
            <i className="fas fa-chevron-down clickable"></i>
          </div>
          {this.props.open || ""}
        </div>
      );
    } else if (this.state.disabled) {
      return (
        <div
          className={`clickable collapsible ${
            this.props.closedContainerClass || ""
          } `}
          onClick={() => alertService.info(this.state.disabledMessage)}
        >
          {this.props.closed || <i className="fas fa-ban"></i>}
        </div>
      );
    } else {
      return (
        <div
          className={`clickable collapsible ${
            this.props.closedContainerClass || ""
          } `}
          onClick={() => this.setState({ hidden: false })}
        >
          {this.props.closed || <i className="fas fa-plus"></i>}
        </div>
      );
    }
  }
}

export default Collapsible;
